import React from 'react'
import { useTranslation } from 'react-i18next'
import { ERROR_PLEASE_CALL } from 'src/config/imageUrls'
import { getImageUrl } from 'src/utils/getImageUrl'
import useStyles from './styles'

export const BookByPhoneScreen = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.root}>
      <img className={classes.image} src={getImageUrl({ src: ERROR_PLEASE_CALL })} alt={'phone'} />

      <p className={classes.message}>{t('book_by_availy_not_possible')}</p>
    </div>
  )
}
